import { observer } from 'mobx-react-lite'
import { Box } from '@mui/material'
import { useELearningStore } from '../store/e-learning.store'
import { useEffect } from 'react'
import { AppCircleLoader } from 'src/component/common/analog/molecule/loader/AppCircleLoader'
import { RecommendedCourses } from '../component/organism/RecommendedCourses'
import { CoursePlanPage } from 'src/feature/profile/page/CoursePlanPage'
import { MyGrowthBanner } from 'src/feature/dashboard/component/MyGrowthBanner'

export const MyCoursesPage = observer(() => {
  const eLearningStore = useELearningStore()
  const { isLoading } = eLearningStore.getGenericFieldsState('updatePersonalCoursePlan')

  useEffect(() => {
    eLearningStore.updatePersonalCoursePlan()
  }, [])

  if (isLoading) {
    return <AppCircleLoader isShowing={true} />
  }

  return (
    <Box sx={styles.root}>
      <CoursePlanPage />
      <RecommendedCourses />
      <MyGrowthBanner />
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    padding: 20,
  },
}
